<template>
  <div class="app-container editForm">
    <div class="detailHead">
      <div class="title">
        <img src="@/assets/images/accident/location.png" alt="" />
        <span
          style="
            color: #9098a3;
            font-size: 16px;
            vertical-align: top;
            margin-left: 5px;
          "
          >事故管理 > {{ accidentTitle }}</span
        >
      </div>
      <div class="btnGroup">
        <button class="back" @click="() => $router.push('/index')">
          <img src="@/assets/images/accident/back.png" />返回
        </button>
        <button
          :class="loading ? 'isDisabled submit' : 'submit'"
          @click="submitAccident"
          v-if="accident.status === 0 || isAdmin"
        >
          <img src="@/assets/images/accident/submit.png" />提交
        </button>
        <button
          @click="() => tempAccident(false)"
          :class="loading ? 'isDisabled' : ''"
        >
          暂存信息
        </button>
        <!-- <button
          @click="sendPhone"
          :class="loading ? 'isDisabled' : ''"
        >
          拨打手机
        </button> -->
        <button
          class="back"
          @click="cancellationAccident"
          v-if="accident.status === 0 || isAdmin"
        >注销事故
        </button>
      </div>
    </div>
    <div class="accident-edit">
      <div class="left-content">
        <!-- 视频 -->
        <div class="videolists" v-if="!($route.name === 'AccidentAdd')">
          <div :class="selectdVideo === index ? 'videoselected changvideobtn':'changvideobtn'" v-for="(item,index) in videoArr" :key="item" @click="changVideo(index)">视频{{index+1}}</div>
        </div>
        <stream-video :accident="accident" v-if="$route.name === 'AccidentAdd'" ref="video" />
        <video-record v-else ref="video" :accident="accident" />
      </div>
      <!-- 案件图片列表 -->
      <div class="right-content">
        <div v-if="currentRole === '保险员'" class="scroll-wrapper">
          <detailStyle :title="'现场证据'">
            <insurancePhoto :is-insurance="accident.insuranceAccidentPhotos" />
          </detailStyle>
        </div>
        <div v-else class="scroll-wrapper">
          <detailStyle :title="'现场证据'">
            <photos :accident-photo-list="accident.accidentPhotoList" />
          </detailStyle>
          <!-- <party-photos
            :accident-partys="accident.accidentPartyList"
            :active-party.sync="activeParty"
          /> -->
        </div>
        <detailStyle class="baseInfo" :title="'事故信息详情'">
          <div class="baseInfo-content">
            <div v-if="accident.id" class="accident-info">
              <div>
                <div class="accident-title">事故编号：</div>
                <el-input v-model="accident.thirdAccidentId ? accident.thirdAccidentId : accident.id" disabled />
              </div>
            </div>
            <!-- 报警类型 -->
            <div>
              <div class="alarmType">
                <div class="accident-title">报警类型</div>
                <el-checkbox-group v-model="checkList" :min="1">
                  <el-checkbox label="1"> 远程定责 </el-checkbox>
                  <el-checkbox label="2"> 车辆救援 </el-checkbox>
                  <el-checkbox label="3"> 人伤直赔 </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
            <div class="accident-status">
              <div class="accident-title">事故状态：</div>
              <span>
                <img src="@/assets/images/accident/icon4.png" alt="" />
                {{
                  (
                    accident_status.find(
                      ({ dictValue }) => dictValue === accident.status + ""
                    ) || {}
                  ).dictLabel
                }}</span
              >
              <span v-if="accident.liability">
                <img src="@/assets/images/accident/icon4.png" alt="" />
                已定责
              </span>
              <span v-else>
                <img src="@/assets/images/accident/icon3.png" alt="" />
                未定责
              </span>
              <span v-if="accident.claim">
                <img src="@/assets/images/accident/icon4.png" alt="" />
                <el-icon name="success" class="text-success" />
                已理赔
              </span>
              <span v-else>
                <img src="@/assets/images/accident/icon3.png" alt="" />
                未理赔
              </span>
            </div>
            <!-- 事故快处 -->
            <div class="isDispose">
              <el-form
                class="notApplicable"
                :model="accident"
                label-position="top"
                :disabled="isDisabledComputed"
              >
                <el-form-item
                  style="margin-bottom: 20px; width: 100%"
                  label="是否适用事故快处"
                  prop="applicable"
                >
                  <el-radio-group
                    :value="accident.applicable"
                    @input="changeApplicable"
                  >
                    <el-radio :label="true"> 适用 </el-radio>
                    <el-radio :label="false"> 不适用 </el-radio>
                  </el-radio-group>
                </el-form-item>
                <template v-if="!accident.applicable">
                  <el-form-item label="线下处理大队" prop="OfflineBrigade">
                    <claimsSelect v-model="OfflineBrigadeId" :isDis="brigadeDis" :type="'OfflineBrigade'" />
                  </el-form-item>
                  <el-form-item label="线下处理交警">
                    <pliceCascader :accident="accident" :applicable="false" :policeDis='policeDis' @PhonData="(data)=>{ OfflinePolice=data }"/>
                  </el-form-item>
                  <el-form-item label="事故备注" prop="remark">
                    <el-input
                      v-model="accident.remark"
                      :rows="1"
                      placeholder="请输入备注"
                      type="textarea"
                    />
                  </el-form-item>
                  <el-form-item label="不适用原因" prop="applicable">
                    <dict-select v-model="accident.naReason" type="na_reason" />
                  </el-form-item>
                  <el-form-item>
                    <div class="offline" @click="sendOffline">转线下处理</div>
                  </el-form-item>
                </template>
              </el-form>
            </div>
            <template>
              <!-- 基础事故信息 -->
              <basic-info-form ref="basicForm" :model="accident" />
            </template>
          </div>
        </detailStyle>
        <!-- 当事人信息 -->
        <detailStyle class="accidentPartys" :title="'当事人信息'">
          <accident-partys
            ref="accidentPartys"
            :active-party.sync="activeParty"
            :accident-party-list="accident.accidentPartyList"
          />
        </detailStyle>
        <div class="operation">
          <!-- 操作记录 -->
          <detailStyle class="operationRecord" :title="'操作记录'">
            <operation-record
              v-if="currentRole === '坐席'"
              ref="operationRecord"
              :accident-id="accident.id"
            />
          </detailStyle>
          <!-- 事故备注 -->
          <detailStyle class="accdientRemark" :title="'事故备注'">
            <div>
              <el-form
                :model="accident"
                label-position="top"
                :disabled="isDisabledComputed"
              >
                <el-form-item prop="remark">
                  <el-input
                    v-model="accident.remark"
                    :rows="4"
                    placeholder="请输入内容"
                    type="textarea"
                  />
                </el-form-item>
              </el-form>
            </div>
          </detailStyle>
        </div>
      </div>
      <liability
        :accident-id="accident.id"
        :visible.sync="liabilityVisible"
        @ok="getAccident"
      />

      <claim
        :accident-id="accident.id"
        :visible.sync="claimVisible"
        @ok="getAccident"
      />
      <sms-dialog
        v-if="accident.id"
        v-model="smsDialogVisible"
        :accident-id="accident.id"
        :parties="accident.accidentPartyList"
      />
    </div>
  </div>
</template>
<script>
import Photos from "../components/Photos";
import insurancePhoto from "../components/insurancePhoto";
import BasicInfoForm from "../components/BasicInfoForm";
import OperationRecord from "../components/OperationRecord";
import VideoRecord from "../components/VideoRecord";
import StreamVideo from "../components/StreamVideo";
import AccidentPartys from "../components/AccidentPartys";

import { getAccident, saveAccident, cancellationAccident } from "@/api/accident/edit";
import Liability from "../components/Liability";
import Claim from "../components/Claim";
import { getListRole } from "@/api/system/role";
// import UploadStatement from '../components/UploadStatement';
import SmsDialog from "@/views/accident/edit/sms-dialog";
import DictSelect from "../components/dict-select.vue";
import { offlineProcessing } from "@/api/accident/upload";
import claimsSelect from "@/views/accident/components/claimsSelect";
import { get } from "@/utils/dict";
import detailStyle from "@/views/accident/components/detailStyle.vue";
import "../common.less";
import pliceCascader from '@/views/accident/components/pliceCascader'
import axios from 'axios';
// import accidentData from '../components/a.json';
export default {
  name: "AccidentEdit",
  components: {
    SmsDialog,
    VideoRecord,
    Photos,
    BasicInfoForm,
    OperationRecord,
    AccidentPartys,
    Liability,
    Claim,
    StreamVideo,
    DictSelect,
    insurancePhoto,
    claimsSelect,
    detailStyle,
    pliceCascader
    // UploadStatement,
  },

  provide() {
    return {
      targetRefs: this.$refs,
      isDisabled: this.isDisabled,
      accident: this.accident,
      checkList: () => this.checkList
    };
  },
  data() {
    return {
      loading: false,
      accident_status: [],
      activeParty: "0",
      smsDialogVisible: false,
      accident: {
        latitude: 0.0,
        longitude: 0.0,
        accidentType: "", // 报警类型
        directIndemnity: "", // 是否接受直赔
        accidentPhotoList: [],
        accidentPartyList: [],
        isInsurance: [], // 保险截图列表
        accidentTime: null,
        applicable: true,
        caseDealType: null,
        crashType: null,
        id: "",
        injuredCount: null,
        policeGroupId: null,
        remark: "",
        reportPhone: "",
        status: null,
        weather: null,
        participants: [],
        accidentAddress: "",
        statementUrl: "",
        isOverpass: "", // 是否高架
        objectDestroyed: "", // 是否物损
        objectName: "", // 物损名称
        policePhone: "", // 警员电话
        policeName: "", // 警员名称
        county: "", // 行政单位
        videoUrl: '', // 视频链接
        thirdAccidentId: null
      },
      videoArr: [], // 用来存储多个视频的链接
      selectdVideo: 0, // 控制视频按钮样式
      liabilityVisible: false,
      claimVisible: false,
      timeout: null,
      isDisabled: { value: false },
      checkList: ["1"], // 报警类型
      offlineId: "", // 线下处理交警id
      OfflineBrigadeId:'', //线下处理大队id
      carLicenseType: null,
      accidentTitle: "事故详情",
      OfflinePolice: '', // 线下处理交警id
      brigadeDis: false, // 是否禁用线下大队
      policeDis: false, // 是否禁用线下交警
    };
  },
  computed: {
    currentRole() {
      return this.$store.getters.accidentRoleName;
    },
    isAdd() {
      return this.$route.name === "AccidentAdd";
    },
    isDisabledComputed() {
      if (this.isAdmin) {
        this.isDisabled.value = false;
        return false;
      }
      if (this.currentRole === "坐席") {
        const value = this.accident.status !== 0;
        this.isDisabled.value = value;
        return value;
      } else {
        this.isDisabled.value = true;
        return true;
      }
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    offlineList() {
      let list =
        this.$store.getters.selecaData.length &&
        this.$store.getters.selecaData.filter(el => {
          const arr =
            el.roles &&
            el.roles.filter(role => {
              return role.roleKey === "OfflineBrigade";
            });
          return arr && arr.length;
        });
      return list;
    }
  },
  watch: {
    // 报警类型转数组
    "accident.accidentType": {
      handler(val) {
        if (val) {
          this.checkList = val.split(",");
        }
      },
      immediate: true,
      deep: true
    },
    "accident.accidentPartyList": {
      handler(val) {
        if (!val.length) {
          this.accident.accidentPartyList.push({
            partyDirectIndemnity: { accidentWoundedList: [{}] }
          });
        } else {
          this.accident.accidentPartyList.forEach(el => {
            if (!el.partyDirectIndemnity) {
              this.$set(el, "partyDirectIndemnity", {
                accidentWoundedList: [{}]
              });
            }
          });
        }
      },
      immediate: true,
      deep: true
    },
    OfflineBrigadeId(val) {
      if (val) {
        console.log(111);
        this.policeDis = true
      }else{
        console.log(222);
        this.policeDis = false
      }
    },
    OfflinePolice(val) {
      if (val) {
        console.log(111);
        this.brigadeDis = true
      }else{
        console.log(222);
        this.brigadeDis = false
      }
    },
  },
  async created() {
    this.accident.id = this.$route.params.id;
    this.getAccident();
    this.getAccidentStatus();
    this.getListRole();
    this.carLicenseType = await get("car_license_type");
    if (this.$route.name === "AccidentEdit") {
      this.accidentTitle = "事故详情";
    } else {
      this.accidentTitle = "新建事故";
    }
  },
  methods: {
    sendPhone() {
      axios.defaults.headers['Content-Type'] = 'application/json';
      let obj = {}
      obj.voiceTemplateId = 100;
      obj.tenantId = 124;
      obj.userId = 3;
      obj.list = [];
      obj.list.push({});
      obj.list[0]['calledNumber'] = '13657083265';
      obj.list[0]['calledUsername'] = '钟11';
      obj.list[0]['certificatesNumber'] = '320922199608115011';
      obj.list[0]['plateNo'] = '苏J03F21';
      obj.list[0]['accidentPlace'] = '江苏无锡盐都区大数据中心'
      obj.list[0]['accidentId'] = '202110260004';
      obj.list[0]['certificatesType'] = '1';
      axios.post('https://ycjjdd.aegis-info.com/api/third/callout',obj).then(res=>{
        console.log(res);
      })
    },
    showSmsDialog() {
      this.smsDialogVisible = true;
    },
    /**
     * 初始化数据，用于切换快处状态时
     */
    changeApplicable(value) {
      if (!value) {
        this.$confirm("事故将转线下处理！", "提示", {
          type: "warning"
        }).then(() => {
          // const {
          //   id,
          //   remark,
          //   status,
          //   applicable,
          //   ...filteredData
          // } = this.$options.data().accident;
          // Object.assign(this.accident, filteredData);
          this.accident.applicable = value;
        });
      } else {
        this.accident.applicable = value;
      }
    },
    /**
     * 获取当前事故
     */
    async getAccident() {
      const { data } = await getAccident(this.accident.id);
      this.videoArr = data.videoUrl && data.videoUrl.split(',')
      this.$nextTick(() => {
        if (this.$refs.operationRecord) {
          this.$refs.operationRecord.getLog();
        }
      });
      console.log('getAccident. data',data)
      Object.assign(this.accident, data);
      if (this.videoArr){
        console.log(this.videoArr);
        this.accident.videoUrl = this.videoArr[this.videoArr.length-1]
        this.selectdVideo = this.videoArr.length-1
        console.log(this.accident);
        this.$store.commit("app/SET_ACTIVEINJURED", "0");
      }
      // this.accident = accidentData;
      return data;
      // if (this.accident.status === 0) {
      //   clearTimeout(this.timeout);
      //   this.timingTemp();
      // }
    },
    /**
     * 获取状态字典
     */
    getAccidentStatus() {
      this.getDicts("accident_status").then(({ data }) => {
        this.accident_status = data;
      });
    },
    // 获取医院，拖修车角色
    getListRole() {
      getListRole().then(res => {
        if (res.code === 0 && res.data) {
          this.$store.commit("app/SET_SELECTDATA", res.data);
        }
      });
    },
    /**
     * 校验所有表单
     */
    validate() {
      let newArr = [];
      if (this.$refs.accidentPartys) {
        const refArr = Object.values(
          this.$refs.accidentPartys.$refs.partyForm
        ).filter(ref => ref && ref.validate);
        if (this.checkList.includes("3")) {
          if (!this.accident.policePhone || !this.accident.policeName) {
            this.$message.error("请选择交警信息！");
            return;
          }
          refArr.forEach(el => {
            if (el.$refs.injuredList) {
              newArr.push(
                ...el.$refs.injuredList.$refs.injuredForm
                  .filter(ref => ref && ref.validate)
                  .map(ref => ref.validate())
              );
            }
          });
        }
      }
      newArr.push(
        ...Object.values(this.$refs)
          .filter(ref => ref && ref.validate)
          .map(ref => ref.validate())
      );
      // console.log(newArr);
      return Promise.all(newArr);
    },
    getCleanData(data) {
      return Object.keys(data).reduce((acc, cur) => {
        let { [cur]: value } = data;
        if (cur === "accidentPartyList" || cur === "accidentPhotoList") {
          value = value
            .map(item => this.getCleanData(item))
            .filter(item => Object.keys(item).length);
        }
        if (value || value === false || value === 0) {
          acc[cur] = value;
        }
        return acc;
      }, {});
    },
    submitAccident() {
      this.validate()
        .catch(() => {
          this.$message.error("校验失败，请检查表单内容");
          throw new Error("校验失败");
        })
        .then(() => {
          this.accident.accidentPartyList.forEach(el => {
            if (el.carLicenseType && isNaN(el.carLicenseType)) {
              this.carLicenseType.forEach(name => {
                if (name.dictLabel === el.carLicenseType) {
                  this.$set(el, "carLicenseType", name.dictValue);
                }
              });
            }
          });
          this.loading = true;
          this.accident.accidentType = this.checkList.join(",");
          return saveAccident(this.getCleanData(this.accident), 2);
        })
        .then(() => {
          this.$message.success("事故提交成功");
          this.getAccident();
          this.$store.commit("app/SET_ISINVITER", false);
          this.$store.dispatch("tagsView/delView", this.$route);
          // this.$router.push({ name: '首页' });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cancellationAccident() {
      cancellationAccident(this.accident.id).then(() => {
        this.$message.success("事故注销成功");
        this.getAccident();
      });
    },
    /**
     * 暂存
     */
    tempAccident(auto = false) {
      this.loading = true;
      let resetTime = setTimeout(() => {
        this.loading = false;
      }, 9000);
      clearTimeout(this.timeout);
      let newArr = [];
      if (this.$refs.accidentPartys) {
        const refArr = Object.values(
          this.$refs.accidentPartys.$refs.partyForm
        ).filter(ref => ref && ref.validate);
        refArr.forEach(el => {
          const aa = el.$refs.form.validateField("idCardNum", error => {
            newArr.push(
              new Promise((resolve, reject) => {
                if (error) {
                  reject(error);
                } else {
                  resolve(true);
                }
              })
            );
          });
        });
        if (this.checkList.includes("3")) {
          if (!this.accident.policePhone || !this.accident.policeName) {
            this.$message.error("请选择交警信息！");
            return;
          }
          refArr.forEach(el => {
            // newArr.push(...(el.$refs.injuredList.$refs.injuredForm
            // .filter(ref => ref && ref.validate)
            // .map(ref => ref.validate())));
            if (
              el.$refs.injuredList &&
              el.$refs.injuredList.$refs.injuredForm
            ) {
              el.$refs.injuredList.$refs.injuredForm[0].$refs.form.validateField(
                "identityNum",
                error => {
                  newArr.push(
                    new Promise((resolve, reject) => {
                      if (error) {
                        reject("伤者" + error);
                      } else {
                        resolve(true);
                      }
                    })
                  );
                }
              );
            }
          });
        }
        // newArr.push(this.$refs.accidentPartys.validate());
      }
      Promise.all(newArr)
        .catch(err => {
          this.$message.error("校验失败，请检查表单内容");
          throw new Error("校验失败");
        })
        .then(() => {
          console.log(1, this.accident.accidentPartyList);
          this.accident.accidentPartyList.forEach(el => {
            if (el.carLicenseType && isNaN(el.carLicenseType)) {
              this.carLicenseType.forEach(name => {
                if (name.dictLabel === el.carLicenseType) {
                  this.$set(el, "carLicenseType", name.dictValue);
                }
              });
            }
          });
          console.log(2, this.accident.accidentPartyList);
          this.loading = true;
          this.accident.accidentType = this.checkList.join(",");
          return saveAccident(this.getCleanData(this.accident), auto ? 0 : 1);
          // saveAccident(this.getCleanData(this.accident), auto ? 0 : 1)
        })
        .then(() => {
          if (!auto) {
            this.$message.success("事故暂存成功");
          }
          this.getAccident();
          this.$store.commit("app/SET_ISINVITER", false);
          // this.timingTemp();
        })
        .finally(() => {
          this.loading = false;
          clearTimeout(resetTime);
        });
    },
    sendOffline() {
      const obj = {}
      obj.userId = this.OfflineBrigadeId ? this.OfflineBrigadeId : null;
      obj.accidentId = this.$route.params && this.$route.params.id ? this.$route.params.id : null
      obj.phoneNumber = this.OfflinePolice ? this.OfflinePolice : null
      obj.accidentRemark = this.accident.remark ? this.accident.remark : null
      // const userId = this.OfflineBrigadeId;
      // const accidentId = this.$route.params && this.$route.params.id;
      // const OfflinePolice = this.OfflinePolice;
      // const accidentRemark = this.accident.remark
      if (String(this.accident.claim) === 'null') {
        this.$message.error('确保当人信息及手机号正确，请先暂存或提交！')
      }else {
        offlineProcessing(obj).then(res => {
          if (res.code === 0) {
            this.$message.success("发送成功！");
          }
        });
      }
    },

    // 切换视频
    changVideo(index) {
      console.log(index);
      this.selectdVideo = index
      this.accident.videoUrl = this.videoArr[index]
      this.videoUrl = this.videoArr[index]
      console.log(this.accident.videoUrl);
    }
    /**
     * 定时暂存
     */
    // timingTemp() {
    //   this.timeout = setTimeout(() => {
    //     this.tempAccident(true);
    //   }, 10000);
    // },
  }
};
</script>
<style lang="scss">
.app-container {
  height: calc(100vh - 90px);
  overflow: auto;
  //background: url("../../../assets/images/list/bgc.png") no-repeat;
  //background-size: 100% 100%;
  &::-webkit-scrollbar {
    /*定义滚动条高宽及背景
    高宽分别对应横竖滚动条的尺寸*/
    width: 0px;
    background-color: #f5f5f5;
  }
  .detailHead {
    position: fixed;
    top: 110px;
    left: 20px;
    width: 100%;
    height: 140px;
    z-index: 99;
    .title {
      margin-bottom: 20px;
    }
    .btnGroup {
      button {
        width: 160px;
        height: 48px;
        background: rgba(0, 132, 255, 0.1);
        border-radius: 4px;
        border: 1px solid #0084ff;
        color: #b1e3ff;
        font-size: 20px;
        letter-spacing: 1px;
        margin-right: 20px;
        cursor: pointer;
        img {
          margin-right: 10px;
        }
      }
      .back {
        background: rgba(255, 125, 0, 0.1);
        border: 1px solid #ff7d00;
      }
      .submit {
        background: rgba(14, 189, 53, 0.1);
        border: 1px solid #0ebd35;
      }
      .isDisabled {
        cursor: not-allowed;
      }
    }
  }
  .accident-edit {
    margin-top: 130px;
    padding-top: 15px;
    position: relative;
    display: flex;
    .el-form--inline {
      .el-form-item {
        width: 300px;
      }
    }
    // .left-content,
    // .right-content {
    //   height: 100%;
    //   margin-top: 0;
    //   overflow: auto;
    //   & > * {
    //     margin-bottom: 15px;
    //   }
    // }

    .left-content {
      width: 800px;
      position: sticky;
      top: 190px;
      display: flex;
      flex-direction: column;
      overflow: initial;
      // position: relative;
      .videolists{
        position: absolute;
        color: white;
        top: 30px;
        left: 41px;
        z-index: 100;
        display: flex;
        .changvideobtn{
          padding: 4px 10px;
          border: 1px solid #0084FF;
          background: rgba(0, 132, 255, 0.1);
          color: #B1E3FF;
          margin-left: 10px;
          cursor: pointer;
          border-radius: 4px;
        }
        .videoselected{
          background: rgba(14, 189, 53, 0.1);
          border-radius: 4px;
          border: 1px solid #0EBD35;
          color: #0EBD35;
        }
      }
      .scroll-wrapper {
        width: 1000px;
        height: 450px;
        flex: 1;
        overflow: scroll;

        &::-webkit-scrollbar {
          width: 0;
        }
      }

      .video-record,
      .stream-video {
        .header {
          width: 100%;
          display: flex;
          align-items: center;

          .header-operator-group {
            flex: 1;
            text-align: right;
            font-weight: 400;
            color: #020202;
            line-height: 17px;
            font-size: 14px;

            .info {
              cursor: pointer;

              .icon {
                color: #004dbe;
              }
            }

            :not(:last-child) {
              margin-right: 20px;
            }
          }
        }
      }
    }

    .right-content {
      flex: 1;
      width: 1000px;
      height: 700px;
      padding-top: 15px;
      margin: -15px 0 0 40px;
      overflow-x: hidden;
      overflow-y: auto;
      &::-webkit-scrollbar {
        /*定义滚动条高宽及背景
        高宽分别对应横竖滚动条的尺寸*/
        width: 6px;
        background: transparent;
      }
      &::-webkit-scrollbar-thumb {
        display: block;
        width: 6px;
        margin: 0 auto;
        border-radius: 10px;
        background: #eee;
      }
      .scroll-wrapper {
        width: 1000px;
      }
      .baseInfo {
        width: 1000px;
        margin-top: 54px;
        .baseInfo-content {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          padding: 55px 80px;
        }
        .accident-info {
          // display: flex;
          // justify-content: space-between;
          font-weight: 500;
          width: 100%;
          color: #020202;

          .accident-number {
            margin: 0;
            font-size: 22px;
            line-height: 28px;
          }
        }
        .accident-status {
          width: 300px;
          font-size: 16px;
          line-height: inherit;
          color: #b1e3ff;
          img {
            vertical-align: middle;
          }
          span {
            margin-right: 15px;
          }
        }
        .applicable {
          box-shadow: 0px 2px 18px 8px rgba(0, 0, 0, 0.05);
          border-radius: 8px;
          height: 110px;
          background: #fff;
          display: flex;
          align-items: center;
          padding: 0 40px;
          font-size: 18px;
          color: #020202;
        }

        .statement {
          cursor: pointer;
          justify-content: center;
          color: #909399;
          height: 200px;
          width: 150px;
          display: flex;
          align-items: center;
          flex-direction: column;
          background: rgba(0, 0, 0, 0.04);
        }

        .operator-group {
          position: fixed;
          top: 95px;
          right: 30px;
          background-color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 999;
        }
        .alarmType {
          font-size: 16px;
          margin-bottom: 40px;
          // display: flex;
          // align-items: center;
          & > span {
            font-weight: 600;
            color: #606266;
          }
        }
        .isDispose {
          width: 100%;
          margin-bottom: 60px;
          .notApplicable {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            .el-form-item {
              width: 300px;
            }
            .offline {
              width: 300px;
              height: 48px;
              margin-top: 15px;
              line-height: 48px;
              text-align: center;
              background: rgba(14, 189, 53, 0.1);
              border-radius: 4px;
              cursor: pointer;
              font-size: 18px;
              letter-spacing: 1px;
              color: #0ebd35;
              border: 1px solid #0ebd35;
            }
          }
        }
      }
      .accidentPartys {
        width: 1000px;
        margin-top: 50px;
        background: rgba(15, 31, 70, 0.6);
      }
      .operation {
        width: 1000px;
        height: 510px;
        margin-top: 40px;
        display: flex;
        justify-content: space-between;
        .operationRecord {
          padding: 45px 20px;
          width: 500px;
          height: 510px;
        }
        .accdientRemark {
          width: 460px;
          height: 510px;
          margin-left: 40px;
          padding: 45px 20px;
          position: relative;
          .el-textarea__inner {
            width: 420px;
            height: 424px;
          }
        }
      }
    }
  }
}

.person-list {
  list-style: none;
  padding: 0;
  margin: 0;
  .role {
    line-height: 20px;
    .role-name {
      font-size: 14px;
    }
    .member-list {
      padding: 0 0 0 13px;
      margin: 0;
      list-style: none;
      font-size: 14px;
      color: #020202;

      .member {
        line-height: 20px;
      }
    }
  }
}
</style>
